class SaconeProductGuide extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    const photo = this.querySelector('[data-so-zoom]');
    const zoomImage = photo?.querySelector('img');
    const zoomButton = this.querySelector('[data-so-zoom-toggle]');
    const caption = this.querySelector('[data-so-zoom-caption]');
    let zoomed = false;
    const setZoom = (active, x = 50, y = 50) => {
      if (!photo || !zoomImage) return;
      if (!active) this.querySelectorAll('[data-so-detail]').forEach(detail => { detail.open = false; });
      const selectedDetail = this.querySelector('[data-so-detail][open]');
      zoomed = active;
      photo.classList.toggle('is-zoomed', active);
      photo.classList.toggle('is-detail-focused', active && !!selectedDetail);
      photo.classList.toggle('has-caption-top', active && !!selectedDetail && y > 60);
      if (active && selectedDetail) {
        x = Math.max(0, Math.min(100, x * 2 - 50));
        y = Math.max(0, Math.min(100, y * 2 - 50));
      }
      zoomImage.style.transformOrigin = `${x}% ${y}%`;
      this.querySelectorAll('[data-so-point]').forEach(point => {
        point.setAttribute('aria-expanded', String(active && selectedDetail?.id === point.getAttribute('aria-controls')));
      });
      zoomButton?.setAttribute('aria-pressed', String(active));
      this.querySelectorAll('[data-so-detail-choice]').forEach(button => {
        const detail = this.querySelector(`#${CSS.escape(button.dataset.soDetailChoice)}`);
        button.setAttribute('aria-pressed', String(active && !!detail?.open));
      });
      if (zoomButton) zoomButton.textContent = active ? 'Vue complète −' : 'Agrandir les détails +';
      const status = this.querySelector('[data-so-zoom-status]');
      if (status) status.textContent = active ? (selectedDetail ? 'Choisissez un autre détail ci-dessous' : 'Déplacez la souris ou glissez sur la photo') : 'Touchez un point pour découvrir le détail';
      if (caption) {
        const detail = this.querySelector('[data-so-detail][open]');
        caption.hidden = !active || !detail;
        if (active && detail) {
          caption.querySelector('[data-so-caption-title]').textContent = detail.querySelector('summary').textContent.replace(/^\s*\d+\.\s*/, '').trim();
          caption.querySelector('[data-so-caption-body]').textContent = detail.querySelector('p')?.textContent.trim() || '';
        }
      }
    };
    if (zoomImage && zoomButton) {
      this.querySelector('[data-so-zoom-tools]').hidden = false;
      if (caption) {
        const choices = document.createElement('div');
        choices.className = 'so-detail-choices';
        choices.setAttribute('role', 'group');
        choices.setAttribute('aria-label', 'Choisir un détail à agrandir');
        this.querySelector('.so-detail-choices')?.remove();
        this.querySelectorAll('[data-so-detail]').forEach(detail => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.soDetailChoice = detail.id;
          button.textContent = detail.querySelector('summary').textContent.replace(/^\s*\d+\.\s*/, '').trim();
          button.setAttribute('aria-pressed', 'false');
          button.addEventListener('click', () => {
            const open = !detail.open || !zoomed;
            this.querySelectorAll('[data-so-detail]').forEach(other => { other.open = other === detail && open; });
            const point = this.querySelector(`[data-so-point][aria-controls="${detail.id}"]`);
            setZoom(open, parseFloat(point?.style.getPropertyValue('--x')) || 50, parseFloat(point?.style.getPropertyValue('--y')) || 50);
          }, options);
          choices.append(button);
          detail.hidden = true;
        });
        this.querySelector('[data-so-zoom-tools]').after(choices);
      }
      this.querySelector('[data-so-views]')?.removeAttribute('hidden');
      zoomButton.addEventListener('click', () => setZoom(!zoomed), options);
      this.querySelector('[data-so-caption-close]')?.addEventListener('click', () => {
        setZoom(false);
        this.querySelectorAll('[data-so-detail]').forEach(detail => { detail.open = false; });
        zoomButton.focus({ preventScroll: true });
      }, options);
      photo.addEventListener('pointermove', event => {
        if (event.target.closest('[data-so-zoom-caption]')) return;
        if (!zoomed || photo.classList.contains('is-detail-focused') || (event.pointerType !== 'mouse' && !event.buttons)) return;
        const rect = photo.getBoundingClientRect();
        zoomImage.style.transformOrigin = `${Math.max(0, Math.min(100, (event.clientX - rect.left) / rect.width * 100))}% ${Math.max(0, Math.min(100, (event.clientY - rect.top) / rect.height * 100))}%`;
      }, options);
      photo.addEventListener('pointerdown', event => {
        if (zoomed && !photo.classList.contains('is-detail-focused') && event.target === zoomImage) photo.setPointerCapture(event.pointerId);
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') setZoom(false);
        if (!zoomed || photo.classList.contains('is-detail-focused') || event.target !== zoomButton || !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key)) return;
        event.preventDefault();
        const [x, y] = zoomImage.style.transformOrigin.split(' ').map(parseFloat);
        setZoom(true, Math.max(0, Math.min(100, x + (event.key === 'ArrowRight' ? 10 : event.key === 'ArrowLeft' ? -10 : 0))), Math.max(0, Math.min(100, y + (event.key === 'ArrowDown' ? 10 : event.key === 'ArrowUp' ? -10 : 0))));
      }, options);
      this.querySelectorAll('[data-so-view]').forEach(button => button.addEventListener('click', () => {
        setZoom(false);
        zoomImage.removeAttribute('srcset');
        zoomImage.src = button.dataset.src;
        this.querySelectorAll('[data-so-view]').forEach(view => view.setAttribute('aria-pressed', String(view === button)));
      }, options));
    }
    this.querySelectorAll('[data-so-point]').forEach(button => {
      button.hidden = false;
      button.addEventListener('click', () => {
        const panel = this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
        if (!panel) return;
        const open = !panel.open;
        this.querySelectorAll('[data-so-detail]').forEach(detail => { detail.open = detail === panel && open; });
        if (photo) setZoom(open, parseFloat(button.style.getPropertyValue('--x')) || 50, parseFloat(button.style.getPropertyValue('--y')) || 50);
      }, options);
    });
    this.querySelectorAll('[data-so-detail]').forEach(detail => {
      detail.addEventListener('toggle', () => {
        if (detail.hidden) return;
        const point = this.querySelector(`[aria-controls="${detail.id}"]`);
        point?.setAttribute('aria-expanded', String(detail.open));
        if (photo && detail.open && point) {
          this.querySelectorAll('[data-so-detail]').forEach(other => { if (other !== detail) other.open = false; });
          setZoom(true, parseFloat(point.style.getPropertyValue('--x')) || 50, parseFloat(point.style.getPropertyValue('--y')) || 50);
        } else if (photo && !this.querySelector('[data-so-detail][open]')) setZoom(false);
      }, options);
    });
    if (photo) {
      const points = [...photo.querySelectorAll('[data-so-point]')];
      const ns = 'http://www.w3.org/2000/svg';
      const links = document.createElementNS(ns, 'svg');
      links.classList.add('so-point-links');
      links.setAttribute('aria-hidden', 'true');
      photo.querySelector('.so-point-links')?.remove();
      photo.insertBefore(links, photo.querySelector('[data-so-point]'));
      const placePoints = () => {
        const { width, height } = photo.getBoundingClientRect();
        if (!width || !height) return;
        links.setAttribute('viewBox', `0 0 ${width} ${height}`);
        links.replaceChildren();
        const placed = [];
        points.forEach(point => {
          const x = parseFloat(point.style.getPropertyValue('--x')) / 100 * width;
          const y = parseFloat(point.style.getPropertyValue('--y')) / 100 * height;
          const radius = point.offsetWidth / 2 || 21;
          const clamp = (value, max) => Math.max(radius + 5, Math.min(max - radius - 5, value));
          let position = { x: clamp(x, width), y: clamp(y, height) };
          let found = false;
          for (let distance = 0; distance <= 160 && !found; distance += 8) {
            for (let angle = 0; angle < 360; angle += 30) {
              const candidate = { x: clamp(x + Math.cos(angle * Math.PI / 180) * distance, width), y: clamp(y + Math.sin(angle * Math.PI / 180) * distance, height) };
              if (placed.every(other => Math.hypot(other.x - candidate.x, other.y - candidate.y) >= radius * 2 + 8)) {
                position = candidate;
                found = true;
                break;
              }
            }
          }
          placed.push(position);
          point.style.left = `${position.x}px`;
          point.style.top = `${position.y}px`;
          if (Math.hypot(position.x - x, position.y - y) > 8) {
            const line = document.createElementNS(ns, 'line');
            for (const [key, value] of Object.entries({ x1: x, y1: y, x2: position.x, y2: position.y })) line.setAttribute(key, value);
            links.append(line);
          }
        });
      };
      this.pointObserver = new ResizeObserver(placePoints);
      this.pointObserver.observe(photo);
      placePoints();
    }
    this.querySelectorAll('[data-so-measure]').forEach(form => {
      form.hidden = false;
      form.addEventListener('input', () => { form.querySelector('[role="status"]').textContent = ''; }, options);
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        const limits = ['height', 'width', 'depth'].map(key => Number(form.elements[key].value));
        const bag = ['height', 'width', 'depth'].map(key => Number(form.dataset[key]));
        const result = form.querySelector('[role="status"]');
        const fits = bag.every((value, index) => value <= limits[index]);
        result.textContent = fits
          ? 'Les dimensions indiquées du sac sont dans les trois limites saisies. Mesurez aussi votre sac une fois rempli : les poches, poignées et l’expansion peuvent modifier son encombrement. Votre billet reste la référence.'
          : 'Au moins une dimension du sac dépasse les limites saisies. Vérifiez la franchise de votre billet ou choisissez un format plus petit avant de commander.';
      }, options);
    });
  }
  disconnectedCallback() { this.abort?.abort(); this.pointObserver?.disconnect(); this.abort = null; }
}
if (!customElements.get('sacone-product-guide')) customElements.define('sacone-product-guide', SaconeProductGuide);

class SaconeFinder extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController();
    const form = this.querySelector('form');
    if (!form) return;
    form.hidden = false;
    form.addEventListener('change', () => {
      this.querySelectorAll('[data-so-choice]').forEach(panel => { panel.hidden = true; });
      this.querySelector('[data-so-finder-status]').textContent = '';
    }, { signal: this.abort.signal });
    form.addEventListener('submit', event => {
      event.preventDefault();
      const use = form.elements.usage.value;
      const laptop = form.elements.laptop.value;
      this.querySelectorAll('[data-so-choice]').forEach(panel => { panel.hidden = panel.dataset.soChoice !== use; });
      this.querySelectorAll('[data-so-laptop-note]').forEach(note => { note.hidden = laptop !== 'yes'; });
      this.querySelector('[data-so-finder-status]').textContent = 'Votre sélection, selon vos réponses';
      const heading = this.querySelector('[data-so-choice]:not([hidden]) h3');
      heading?.focus({ preventScroll: true });
      heading?.closest('article')?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
    }, { signal: this.abort.signal });
  }
  disconnectedCallback() { this.abort?.abort(); this.abort = null; }
}
if (!customElements.get('sacone-finder')) customElements.define('sacone-finder', SaconeFinder);
